<template>
  <div>
    <Applications class="mt-4" />
  </div>
</template>

<script>
import Applications from './Brokers.vue';

export default {
  name: 'index',
  components: {
    Applications,
  },
};
</script>
